import { makeVar } from '@apollo/client';
import { IGridFormat } from '../graphql/useUpdateMainDirectoryWorkspace';

export const columnFormat = makeVar<IGridFormat[]>([]);
export const loadingDirectory = makeVar<boolean>(false);

type EntrySearchEvents = {
    visible: boolean;
    result?: (ids: string[]) => void;
};

export const showEntrySearchScreen = makeVar<EntrySearchEvents>({ visible: false });
